import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Fab } from '@material-ui/core';
import colors from '../../../theme/colors';

export type FloatingActionProps = {
  id?: string;
  /** for testing purposes, allows querying by data-testid */
  testid?: string;
  /** Where the button can be anchored */
  anchor: 'bottomCenter' | 'bottomLeft' | 'bottomRight';
  /** The content that will be rendered in the button */
  buttonContent: React.ReactNode;
  /** Called when the button is clicked */
  onClick?: () => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    floatingActionButton: {
      position: 'fixed',
      color: colors.white,
      backgroundColor: colors.madison,
      bottom: theme.spacing(4),
      top: 'auto',
      width: 64,
      height: 64,
      '&:hover': {
        backgroundColor: colors.onahau,
        color: colors.madison,
      },
      '&:active': {
        backgroundColor: colors.madison,
        color: colors.bright_turquoise,
      },
    },
    centerPosition: {
      left: '50%',
      marginLeft: -32,
    },
    leftPosition: {
      left: theme.spacing(4),
      right: 'auto',
    },
    rightPosition: {
      right: theme.spacing(4),
      left: 'auto',
    },
  }),
);

const FloatingActionButton = ({
  id,
  testid,
  buttonContent,
  anchor,
  onClick,
}: FloatingActionProps): JSX.Element => {
  const classes = useStyles();
  let positionClass: string;

  switch (anchor) {
    case 'bottomCenter':
      positionClass = classes.centerPosition;
      break;
    case 'bottomLeft':
      positionClass = classes.leftPosition;
      break;
    default:
      positionClass = classes.rightPosition;
      break;
  }

  return (
    <Fab
      id={id}
      data-testid={testid}
      data-anchor={anchor}
      className={`${classes.floatingActionButton} ${positionClass}`}
      onClick={onClick}
    >
      {buttonContent}
    </Fab>
  );
};

export default FloatingActionButton;
